
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCopyBalance = (params) => {
    return axios.post(`${backendHost}/api/admin/replenishment/copy`, params);
};

export {
    postCopyBalance
}